module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header fixed-top",
    class: _vm.$style.root
  }, [_c('progress-bar'), (_vm.navOpen) ? _c('div', {
    staticClass: "modal-backdrop navigation-backdrop show",
    on: {
      "click": _vm.closeNavigation
    }
  }) : _vm._e(), _c('b-navbar', {
    attrs: {
      "toggleable": "toggleable",
      "toggle-breakpoint": "lg"
    }
  }, [(_vm.userFullName || _vm.showLanguageSelector) ? _c('b-nav-toggle', {
    attrs: {
      "target": "navCollapse"
    }
  }) : _vm._e(), _c('b-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": {
        name: "home"
      },
      "name": "link_header_logo_to_home"
    }
  }, [_c('div', {
    staticClass: "header-logo",
    style: (_vm.getDynamicLogo)
  })]), _c('b-collapse', {
    ref: "headerNav",
    staticClass: "top-navigation",
    class: {
      isMobile: _vm.isMobile
    },
    attrs: {
      "id": "navCollapse",
      "is-nav": "is-nav"
    }
  }, [(_vm.userFullName) ? _c('div', {
    staticClass: "welcome menu-box d-lg-none"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('pos.header.user', {
    name: _vm.userFullName
  })))])]) : _vm._e(), _c('b-navbar-nav', {
    staticClass: "ml-auto",
    attrs: {
      "is-nav-bar": "is-nav-bar"
    }
  }, [(_vm.userFullName) ? _vm._l((_vm.topMenuItems), function(item) {
    return _c('b-nav-item', {
      key: item.to.name,
      attrs: {
        "active": _vm.getActiveClass(item.to.name),
        "to": item.to
      },
      on: {
        "!click": function($event) {
          _vm.onNavigateTo(item.to)
        }
      }
    }, [_vm._v(_vm._s(item.text))])
  }) : _vm._e(), _c('div', {
    staticClass: "d-lg-none padding-menu",
    class: {
      mobile: _vm.notLoggedIn
    }
  }, [_c('submenu', {
    attrs: {
      "subMenuItems": _vm.subMenuItems,
      "availableLanguages": _vm.availableLanguages
    },
    on: {
      "logout": _vm.logout,
      "changeLanguage": _vm.localeSelect
    }
  })], 1)], 2), _c('b-navbar-nav', {
    attrs: {
      "is-nav-bar": ""
    }
  }, [(_vm.userFullName) ? _c('b-nav-item-dropdown', {
    staticClass: "desktop-dropdown",
    attrs: {
      "right-alignment": "right-alignment"
    }
  }, [_c('template', {
    slot: "text"
  }, [(_vm.userFullName) ? _c('div', {
    staticClass: "username username-header"
  }, [_vm._v(_vm._s(_vm.$t('pos.header.user', {
    name: _vm.userFullName
  }))), _c('icon', {
    staticClass: "menu-chevron",
    attrs: {
      "name": "chevron-down"
    }
  })], 1) : (_vm.showLanguageSelector) ? _c('div', {
    staticClass: "username"
  }, [_vm._v(_vm._s(_vm.$t('locale_native_name'))), _c('icon', {
    staticClass: "menu-chevron",
    attrs: {
      "name": "chevron-down"
    }
  })], 1) : _vm._e()]), _c('submenu', {
    attrs: {
      "subMenuItems": _vm.subMenuItems
    },
    on: {
      "logout": _vm.logout,
      "changeLanguage": _vm.localeSelect
    }
  })], 2) : _vm._e(), (_vm.showLanguageSelector) ? _c('b-nav-item-dropdown', {
    staticClass: "desktop-dropdown language-selector",
    attrs: {
      "right-alignment": "right-alignment"
    }
  }, [_c('submenu', {
    attrs: {
      "availableLanguages": _vm.availableLanguages,
      "hideLogout": true
    },
    on: {
      "changeLanguage": _vm.localeSelect
    }
  })], 1) : _vm._e()], 1)], 1)], 1), (_vm.offlineModeEnabled) ? _c('offline-mode', {
    ref: "offlineMode"
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57359e66"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/gotu-vue-common/src/components/header/Header.vue
// module id = 2045
// module chunks = 1